import React from 'react';
import PropTypes from 'prop-types';

const reqSvgs = require.context(
  '../../../build/Images/Products',
  true,
  /\.svg|\.png$/
);

const svgs = reqSvgs.keys().reduce((images, path) => {
  let imageName = path.split('/')[1].split('.')[0];
  images[imageName] = reqSvgs(path);
  return images;
}, {});

const DraggableIcon = (props) => {
  return (
    <img
      src={svgs[props.id]}
      alt="draggable icon"
      className="slds-avatar slds-avatar_medium"
    />
  );
};

DraggableIcon.propTypes = {
  id: PropTypes.string.isRequired,
};

export default DraggableIcon;
